import { Routes } from '@angular/router';
import { HomeComponent } from './features/public/home/home.component';
import { AboutComponent } from './features/public/about/about.component';
import { ContactComponent } from './features/public/contact/contact.component';
import { ErrorComponent } from './shared/error/error.component';
import { ChatComponent } from './features/public/chat/chat.component';
import { ProgramsComponent } from './features/public/programs/programs.component';
import { NewsComponent } from './features/public/news/news.component';
import { ControlNewsComponent } from './features/dashboard/control-news/control-news.component';
import { AuthGuard } from './core/guards/auth.guard'; 
import { NewComponent } from './features/public/new/new.component';

export const routes: Routes = [
    {path:"", redirectTo:"home", pathMatch:'full'}, 
    {path:"home", title:'راديو الغردقة | عيش معانا جو البحر وأنغامه', component:HomeComponent},
    {path:"about", title:'راديو الغردقة | حكايتنا تبدأ من قلب البحر الأحمر', component:AboutComponent},
    {path:"contact", title:'راديو الغردقة | كلمنا وخليك جزء من الحكاية', component:ContactComponent},
    {path:"chat", title:'راديو الغردقة | دردش معانا.. صوتك ليه معنى', component:ChatComponent},
    {path:"programs", title:'راديو الغردقة | جدول البرامج', component:ProgramsComponent},
    {path:"news", title:'راديو الغردقة | أخبار المدينة', component:NewsComponent},
    {path:"news/:id", title:'راديو الغردقة | تفاصيل الخبر', component:NewComponent},
    {path:"control-news", title:'راديو الغردقة | لوحة التحكم للأخبار', component:ControlNewsComponent , canActivate: [AuthGuard]},
    {path:"**", title:'راديو الغردقة | شكلها غلطة! ارجع للصفحة الصح واستمتع بالنغم', component:ErrorComponent}
]; 